import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-seo-keyword-insight-list',
  templateUrl: './seo-keyword-insight-list.component.html',
  styleUrls: ['./seo-keyword-insight-list.component.css'],
})
export class SeoKeywordInsightListComponent implements OnInit {
  url = 'seoKeywordInsights';
  insightList: any[] = [];
  loading: boolean = true;
  summary: any = {
    total: 0,
    informational: 0,
    transactional: 0,
    commercial: 0,
    navigational: 0,
    local: 0,
    mixed: 0,
  };

  displayedColumns: string[] = [
    'url',
    'primaryKeyword',
    'type',
    'searchIntent',
    'lastSeenAt',
    'actions',
  ];

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/observability/seo/metricsDaily',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/observability/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/observability/social',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'MEDIAROOM',
      route: '/observability/mediaroom',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'LOGISTICS',
      route: '/observability/logistics',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-receipt',
      bgClass: 'bg-white',
      desc: 'ACCOUNTING',
      route: '/observability/accounting',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-coins',
      bgClass: 'bg-white',
      desc: 'FINANCE',
      route: '/observability/finance',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'HR',
      route: '/observability/hr',
    },
  ];

  constructor(private dataService: DataService) {}

  ngOnInit(): void {
    this.loadInsights();
  }

  loadInsights(): void {
    this.loading = true;
    this.dataService.getData(this.url).subscribe({
      next: (res) => {
        if (res.rst) {
          this.insightList = res.data;
          this.calculateSummary();
        }
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  calculateSummary(): void {
    this.summary = {
      total: this.insightList.length,
      informational: this.insightList.filter(
        (i) => i.searchIntent === 'informational',
      ).length,
      transactional: this.insightList.filter(
        (i) => i.searchIntent === 'transactional',
      ).length,
      commercial: this.insightList.filter(
        (i) => i.searchIntent === 'commercial',
      ).length,
      navigational: this.insightList.filter(
        (i) => i.searchIntent === 'navigational',
      ).length,
      local: this.insightList.filter((i) => i.searchIntent === 'local').length,
      mixed: this.insightList.filter((i) => i.searchIntent === 'mixed').length,
    };
  }
}
